import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  TextField,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useVoiceSettingsStyles } from './styles';

interface Props {
  apiKey: string;
  baseUrl: string;
  disabled: boolean;
  onChange: (key: 'apiKey' | 'baseUrl', value: string) => void;
}

export const VoiceConnectionSettings = ({ apiKey, baseUrl, disabled, onChange }: Props) => {
  const { t } = useTranslation();
  const { classes } = useVoiceSettingsStyles();
  return (
    <Accordion disableGutters elevation={0} className={classes.section}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        id="voice-connection-header"
        aria-controls="voice-connection-content">
        <Box className={classes.summaryRow}>
          <Typography variant="subtitle1">{t('superAdminManageVoice.connection.title')}</Typography>
          {/* Signals presence only: the task forbids showing the key in plain text. */}
          {apiKey.trim() !== '' && (
            <Chip size="small" label={t('superAdminManageVoice.connection.apiKeySet')} />
          )}
        </Box>
      </AccordionSummary>
      <AccordionDetails id="voice-connection-content">
        <Box className={classes.fieldsGrid}>
          <TextField
            id="voice-base-url"
            fullWidth
            autoComplete="off"
            label={t('superAdminManageVoice.connection.baseUrl')}
            value={baseUrl}
            disabled={disabled}
            onChange={(event) => onChange('baseUrl', event.target.value)}
          />
          <TextField
            id="voice-api-key"
            fullWidth
            type="password"
            autoComplete="new-password"
            label={t('superAdminManageVoice.connection.apiKey')}
            value={apiKey}
            disabled={disabled}
            onChange={(event) => onChange('apiKey', event.target.value)}
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
